
import { ref } from 'vue'
import axios from '@/plugins/w/axios/models/axios'
import { useStore } from 'vuex'

const api = {
	getCapacityInfo: (userId, date) => axios.get_auth(`/report/proxy/users/${userId}/capacity?date=${date}`),
}

export function useCheckedCapacity() {
	let store = useStore()

	const isNextMonthChecked = ref(true)
	const checkedCapacity = ref(true)
	const capacityBannerType = ref('unchecked') // 'unchecked' or 'needs_work'
	const getCapacityInformation = async () => {		
		try {
			let user = await store.getters['projectsStore/getUser']
			const wholeDate = new Date() 
			const date = new Date().toISOString().slice(0, 7) // Formát: YYYY-MM
			const today = wholeDate.getDate() // Získanie aktuálneho dňa v mesiaci
			const capacity = await api.getCapacityInfo(user.userId, date + '-01')
			checkedCapacity.value = capacity.overview.checkedMonth ? true : false

			if (today < 15) {
				// console.log('dnes ak vsetko funguje je menej ako 15steho, dnes je:', today)
			} else {
				wholeDate.setMonth(wholeDate.getMonth() + 1)
				const month = wholeDate.toISOString().slice(0, 7) // Formát: YYYY-MM

				try {
					const dt = await api.getCapacityInfo(user.userId, `${month}-01`)
					capacityBannerType.value = dt.overview.advancedChecked ?? 'checked'
					isNextMonthChecked.value = dt.overview.checkedMonth ? true : false
				} catch (error) {
					if (error.response.data.error === 'UserMonthStamp not found') {
						console.log('pouzivatel nema vytvoreny month stamp na dalsi mesiac')
						isNextMonthChecked.value = false
						console.log(isNextMonthChecked.value)
					} else {
						console.error('Chyba pri získavaní informácií o kapacite pre nasledujúci mesiac:', error)
					}
				}
			}
		} catch (error) {
			console.error(
				'CAPACITOR REMINDER ERROR: Runtime error while getting capacity information',
				error
			)
		}
	}

	return {
		isNextMonthChecked,
		checkedCapacity,
		getCapacityInformation,
		capacityBannerType,
	}
}
